import { render } from "./HelloWorld.vue?vue&type=template&id=ad0ee508&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=ad0ee508&scoped=true&lang=scss"

import exportComponent from "/Users/migueljr/Desktop/santosapato/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad0ee508"]])

export default __exports__